<nav class="navbar navbar-expand-sm menu-bar justify-content-between">
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="create($event)">สร้างรายงานการติดต่อ</a>
    </li>
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="forward($event)">ส่งต่อรายงานการติดต่อ</a>
    </li>
    <li class="nav-item">
      <a class="nav-link action-menu" (click)="delete($event)">ลบ</a>
    </li>
  </ul>
  <form class="form-inline">
    <input class="form-control filter" type="search" placeholder="Search">
  </form>

</nav>

<div class="card card-default mt-3">
  <div class="card-header">
    <h3 class="card-title text-cust-blue">Share รายงานการติดต่อ</h3>
  </div>
  <!-- /.card-header -->
  <div class="card-body p-0">
    <table id="example2" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearchAll">
              <span class="checkmark"></span>
            </label>
          </th>
          <th>Title</th>
          <th>ผู้ติดต่อ</th>
          <th>Origin Source</th>
          <th>Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <label class="checktable">
              <input type="checkbox" id="cbsearch1">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>สอบถามเรื่องการคุ้มครองเงินฝาก</td>
          <td>ทองดี อยู่เย็น</td>
          <td>Email</td>
          <td>New</td>
          <td>21 Oct 2019</td>
        </tr>

        <tr>
          <td>
            <label class="checktable">
              <input type="checkbox" id="cbsearch1">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>สอบถามเรื่องของข้อกฎหมาย</td>
          <td>ทองเป็น อยู่ดี</td>
          <td>Customer Portal</td>
          <td>Agent 2</td>
          <td>02 Dec 2019</td>
        </tr>

        <tr>
          <td>
            <label class="checktable">
              <input type="checkbox" id="cbsearch2">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>แจ้งปัญหาการขอรับเงินฝากคืน</td>
          <td>ทองมี ศรีกุก</td>
          <td>Call center</td>
          <td>Agent 2</td>
          <td>02 Dec 2019</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<div class="card card-default mt-3">
  <div class="card-header">
    <h3 class="card-title text-cust-blue">รายงานการติดต่อของฉัน</h3>
  </div>
  <!-- /.card-header -->
  <div class="card-body p-0">
    <table id="example2" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearchAll">
              <span class="checkmark"></span>
            </label>
          </th>
          <th>Title</th>
          <th>ผู้ติดต่อ</th>
          <th>Origin Source</th>
          <th>Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <label class="checktable">
              <input type="checkbox" id="cbsearch4">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>วงเงินคุ้มครอง</td>
          <td>ทองสุขมากมี</td>
          <td>Call center</td>
          <td>In Progress</td>
          <td>13 Jan 2020</td>
        </tr>

      </tbody>
    </table>
  </div>

</div>

<div class="card card-default mt-3">
  <div class="card-header">
    <h3 class="card-title text-cust-blue">รายงานการติดต่อที่ฉันสร้าง</h3>
  </div>
  <!-- /.card-header -->
  <div class="card-body p-0">
    <table id="example2" style="width:100%" class="table table-bordered table-hover result-table">
      <thead>
        <tr>
          <th class="col-checked">
            <label class="checktable">
              <input type="checkbox" id="cbsearchAll">
              <span class="checkmark"></span>
            </label>
          </th>
          <th>Title</th>
          <th>ผู้ติดต่อ</th>
          <th>Origin Source</th>
          <th>Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <label class="checktable">
              <input type="checkbox" id="cbsearch1">
              <span class="checkmark"></span>
            </label>
          </td>
          <td>สอบถามเรื่องการคุ้มครองเงินฝาก</td>
          <td>ทองสุข มากมี</td>
          <td>Customer Portal</td>
          <td>In Progress</td>
          <td>21 Oct 2019</td>
        </tr>

      </tbody>
    </table>
  </div>

</div>


<!-- Modal Email-->
<div class="modal fade" id="createModal" tabindex="-1" role="dialog" aria-labelledby="createModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-cust-blue">
        <h5 class="modal-title" id="createModalLabel">รายงานการติดต่อ - New</h5>
      </div>
      <div class="modal-body">
        <div class="row">

          <div class="col-6"></div>
          <div class="col-3 text-right">
            <label>ประเภทรายงานการติดต่อ</label>
          </div>
          <div class="col-3">
            <select class="form-control">
              <option>Chat Issue</option>
            </select>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 text-right">
            <label>ผู้ติดต่อ</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" value="ไลน์ไอดี">
          </div>
          <div class="col-3 text-right">
            <label>หมายเลขโทรศัพท์</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" value="0851454545">
          </div>
        </div>
        <div class="row mt-3">

          <div class="col-3 text-right">
            <label>สถานะรายงานการติดต่อ</label>
          </div>
          <div class="col-3">
            <select class="form-control" disabled>
              <option selected>New</option>
            </select>
          </div>
          <div class="col-3 text-right">
            <label>Origin Source</label>
          </div>
          <div class="col-3">
            <select class="form-control">
              <option selected>สอบถาม</option>
            </select>
          </div>
        </div>
        <div class="row mt-3">

          <div class="col-3 text-right">
            <label>Title/Subject</label>
          </div>
          <div class="col-9">
            <select class="form-control">
              <option selected>วงเงินคุ้มครอง</option>
            </select>
          </div>
        </div>
        <div class="row mt-3">

          <div class="col-3 text-right">
            <label>รายละเอียด</label>
          </div>
          <div class="col-9">
            <textarea class="form-control" rows="3">อยากทราบรายละเอียดเกี่ยวกับวงเงินคุ้มครอง เป็นอย่างไร</textarea>
          </div>

        </div>
        <div class="row mt-3">
          <div class="col-3 text-right">
            <label>ตอบ</label>
          </div>
          <div class="col-9">
            <textarea class="form-control" rows="3"></textarea>
          </div>

        </div>

        <div class="row mt-3">

          <div class="col-3 text-right">
            <label>วันที่สร้าง Case</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" readonly value="19 Oct 2020">
          </div>
          <div class="col-3 text-right">
            <label>วันที่ Update Case ล่าสุด</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control">
          </div>
        </div>

        <div class="row mt-3">

          <div class="col-3 text-right">
            <label>ผู้สร้างข้อมูล Case</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" readonly value="Agent 2">
          </div>
          <div class="col-3 text-right">
            <label>ผู้แก้ไขข้อมูล Case</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control">
          </div>
        </div>

        <div class="row mt-3">

          <div class="col-6"></div>
          <div class="col-3 text-right">
            <button class="btn btn-info">
              <span class="fa fa-paperclip"></span>
              Attatch File
            </button>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" readonly>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-ok m-2" (click)="confirmEmail()">
              <span class="fa fa-check"></span>
              บันทึกรายการติดต่อ
            </button>
            <button type="button" class="btn btn-info m-2" (click)="confirmEmail()">
              <span class="fa fa-paper-plane"></span>
              ส่งต่อรายงานการติดต่อ
            </button>
            <button type="button" class="btn btn-cancel m-2" (click)="CloseModal('createModal')">
              <span class="fa fa-times"></span>
              ปิด
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal Forward-->
<div class="modal fade" id="forwardModal" tabindex="-1" role="dialog" aria-labelledby="forwardModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="forwardModalLabel">Select Email template</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label>กลุ่มงาน</label>
          </div>
          <div class="col-7">
            <select class="form-control select2">
            </select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label>ผู้ใช้งาน</label>
          </div>
          <div class="col-7">
            <select class="form-control select2">
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-ok mr-2" (click)="confirmForward()">OK</button>
            <button type="button" class="btn btn-cancel ml-2" (click)="CloseModal('forwardModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Delete-->
<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="deleteModalLabel">Select Email template</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label>เลือก Email Template</label>
          </div>
          <div class="col-7">
            <select class="form-control select2">
            </select>
          </div>

          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-ok mr-2" (click)="confirmDelete()">OK</button>
            <button type="button" class="btn btn-cancel ml-2" (click)="CloseModal('deleteModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/contact-report/contact-report.component.html